import {
  Button,
  Flex,
  SimpleGrid,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { predictivesCategories } from "../../../utils/SubCategorys";
import { whitelabel_id } from "../../../api";
import PredctiveCard from "./PredctiveCard";
import { useInfinitePredictives } from "../../../hooks/usePredictives";
import {
  AccordionDescriptions,
  AccordionDoubts,
  IAccordionDoubtsItem,
  InfoPredix,
  Skeleton,
} from "../../../components";
import AccordionDescriptionsItem from "../../../components/Accordion/AccordionDescriptions/AccordionItem";
import { useState } from "react";
import { PresentionChart } from "iconsax-react";
import { useMediaQuery } from "@mantine/hooks";

export default function Predictives() {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const isLargerThan991 = useMediaQuery("(min-width: 991px)");
  const { predictiveCategory = "" } = useParams<{
    predictiveCategory?: string;
  }>();
  const [accordionValue, setAccordionValue] = useState<string[]>(["Doubts"]);

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
    useInfinitePredictives({
      page: 1,
      category: predictiveCategory,
      white_label_id: whitelabel_id,
    });

  const rawDoubts = t("marketplace.predix.doubts", {
    returnObjects: true,
    defaultValue: [],
  });

  const doubts: IAccordionDoubtsItem[] = Array.isArray(rawDoubts)
    ? rawDoubts
    : [];

  return (
    <Flex
      direction="column"
      w="100%"
      align={"center"}
      bg={theme.colors.other[0]}
      mih="100%"
    >
      <Flex
        w="100%"
        id={"predix"}
        justify={"center"}
        pb={{ base: "1rem", 991: "2rem" }}
        bg={theme.colors.other[3]}
        px={{ base: "1.5rem", 991: "3.75rem" }}
      >
        <Flex
          align={"center"}
          mb={"unset"}
          maw="105rem"
          w="100%"
          style={{ position: "relative" }}
        >
          <InfoPredix />
          <Text
            display={{ base: "none", 991: "block" }}
            fw={700}
            fz={{ base: "20vw", 991: "15vw", 1920: "17.5rem" }}
            lh={"100%"}
            sx={{
              position: "absolute",
              right: "0",
              top: "0",
              whiteSpace: "nowrap",
              background: `linear-gradient(180deg, ${theme.colors.basic[0]} -50%, rgba(255, 255, 255, 0) 85%)`,
              backgroundClip: "text",
              textFillColor: "transparent",
            }}
          >
            {"PrediX"}
          </Text>
        </Flex>
      </Flex>
      <Flex
        h="fit-content"
        direction="column"
        w="100%"
        justify={"center"}
        align={"center"}
        bg={`linear-gradient(180deg,${theme.colors.other[3]} 2rem, ${theme.colors.other[0]} 2rem)`}
        px={{ base: "1.5rem", 991: "3.75rem" }}
      >
        <Flex
          align="center"
          direction={"column"}
          mb={"2rem"}
          w="100%"
          maw="105rem"
        >
          <Flex w="100%" wrap="wrap" gap="1rem">
            <SimpleGrid
              spacing={16}
              breakpoints={[
                { minWidth: 700, cols: 2 },
                { minWidth: 1200, cols: 3 },
                { minWidth: 1600, cols: 3 },
              ]}
              w="100%"
            >
              {isLoading
                ? Array.from({ length: 6 }).map((_, i) => (
                    <Skeleton key={i} repeat={1} h="11.25rem" w="100%" />
                  ))
                : data?.pages.map((page) =>
                    page.data.map((predictive, index: number) => {
                      return (
                        <PredctiveCard
                          data={predictive}
                          key={`${predictive.id}-${index}`}
                        />
                      );
                    })
                  )}
            </SimpleGrid>
          </Flex>
          {!!hasNextPage && (
            <Button
              w={{ base: "100%", 991: "15.875rem" }}
              variant="primaryTransparent"
              mt={{ base: "1.5rem", 991: "3rem" }}
              onClick={() => fetchNextPage()}
              loading={isFetchingNextPage}
              disabled={!hasNextPage}
            >
              {isFetchingNextPage
                ? t("global.button.loading")
                : t("global.button.loading_more")}
            </Button>
          )}
          {doubts.length > 0 ? (
            <Flex
              w="100%"
              direction="column"
              gap="1.5rem"
              mt="1.5rem"
              bg="basic.0"
              style={{
                border: `1px solid ${theme.colors.basic[2]}`,
                borderRadius: "0.75rem",
                overflow: "hidden",
              }}
            >
              <AccordionDescriptions
                accordionValue={accordionValue}
                setAccordionValue={setAccordionValue}
              >
                <AccordionDescriptionsItem
                  value="Doubts"
                  Icon={PresentionChart}
                  Panel={
                    <Flex
                      direction="column"
                      gap="1.5rem"
                      w="100%"
                      bg={theme.colors.basic[0]}
                      style={{
                        boxShadow: isLargerThan991
                          ? "none"
                          : "0px 1.5625rem 2.1875rem rgba(0, 0, 0, 0.03)",
                        borderRadius: isLargerThan991 ? "none" : "0.75rem",
                      }}
                    >
                      <AccordionDoubts data={doubts} />
                    </Flex>
                  }
                  title={t("marketplace.detalhe.doubt_general.title")}
                />
              </AccordionDescriptions>
            </Flex>
          ) : null}
        </Flex>
      </Flex>
    </Flex>
  );
}
